import { render, staticRenderFns } from "./PushProductsModal.vue?vue&type=template&id=566a1be8&scoped=true&"
import script from "./PushProductsModal.vue?vue&type=script&lang=js&"
export * from "./PushProductsModal.vue?vue&type=script&lang=js&"
import style0 from "./PushProductsModal.vue?vue&type=style&index=0&id=566a1be8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566a1be8",
  null
  
)

export default component.exports